import {
  PROGRESSBAR_VIEW_REQUEST, PROGRESSBAR_VIEW_FAIL, PROGRESSBAR_VIEW_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Home Action",
  result: [],
  msg: "",
  error: "",
};

const ProfileProgressBarReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROGRESSBAR_VIEW_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case PROGRESSBAR_VIEW_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case PROGRESSBAR_VIEW_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };
    default:
      return state;
  }
};

export default ProfileProgressBarReducer;
